import React from 'react';
import styles from './Entertainment.module.css';

const Entertainment = ({ lang }) => {
  const data = {
    EN: {
      title: "Entertainment Pulse",
      btn: "Load More Stories",
      news: [
        { cat: "Movies", title: "The biggest box office hits of 2026" },
        { cat: "Music", title: "Behind the scenes of the Summer Tour" },
        { cat: "Celebrity", title: "Fashion moments at the Gala" },
        { cat: "Gaming", title: "New console release dates announced" },
        { cat: "Streaming", title: "Top 10 binge-worthy series" },
        { cat: "Music", title: "Viral pop songs of the week" },
        { cat: "Movies", title: "Director's cut: The hidden secrets" },
        { cat: "Lifestyle", title: "Celebrity home makeovers" },
        { cat: "Gaming", title: "Esports tournament global finals" },
        { cat: "Celebrity", title: "Exclusive interview with the star" },
        { cat: "Movies", title: "Upcoming award show predictions" },
        { cat: "Streaming", title: "The rise of indie animation" }
      ]
    },
    UR: {
      title: "انٹرٹینمنٹ پلس",
      btn: "مزید کہانیاں لوڈ کریں",
      news: [
        { cat: "موویز", title: "2026 کی سب سے بڑی باکس آفس ہٹ فلمیں" },
        { cat: "میوزک", title: "سمر ٹور کے پردے کے پیچھے کی کہانی" },
        { cat: "سلیبریٹی", title: "گالا میں فیشن کے حسین لمحات" },
        { cat: "گیمنگ", title: "نئے کنسول کی ریلیز کی تاریخوں کا اعلان" },
        { cat: "اسٹریمنگ", title: "ٹاپ 10 دیکھنے کے قابل سیریز" },
        { cat: "میوزک", title: "اس ہفتے کے وائرل پاپ گانے" },
        { cat: "موویز", title: "ڈائریکٹرز کٹ: فلموں کے چھپے راز" },
        { cat: "لائف اسٹائل", title: "سلیبریٹی گھروں کی تبدیلی" },
        { cat: "گیمنگ", title: "ای اسپورٹس ٹورنامنٹ کے عالمی فائنلز" },
        { cat: "سلیبریٹی", title: "اسٹار کے ساتھ خصوصی انٹرویو" },
        { cat: "موویز", title: "آنے والے ایوارڈ شوز کی پیش گوئیاں" },
        { cat: "اسٹریمنگ", title: "انڈی اینیمیشن کا بڑھتا ہوا رجحان" }
      ]
    }
  }[lang];

  return (
    <section className={styles.entSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.entGrid}>
        {data.news.map((item, i) => (
          <div key={i} className={styles.entCard}>
            <div className={styles.imgWrapper}>
              <img src={`https://picsum.photos/400/300?random=${i + 2000}`} alt="ent" />
            </div>
            <div className={styles.cardBody}>
              <span className={styles.category}>{item.cat}</span>
              <h4>{item.title}</h4>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.moreBtnWrapper}>
        <button className={styles.moreBtn}>{data.btn}</button>
      </div>
    </section>
  );
};

export default Entertainment;